import z from 'zod';

import { passwordCopy, passwordSchema } from '@nesso/ui/lib/password.schema';

export const validationCopy = {
    email: 'Enter a valid email address (e.g., name@example.com)',
    passwordEmpty: passwordCopy.empty,
    passwordComplexity: passwordCopy.complexity,
} as const;

export const signUpWithEmailSchema = z.object({
    email: z.email(validationCopy.email).min(1, validationCopy.email),
    password: passwordSchema,
});

export type SignUpWithEmailValues = z.input<typeof signUpWithEmailSchema>;
